import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { AppointmentKeyModel } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { DealerViewModel } from 'projects/Administration/src/app/business-entities/dealer-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { AppointmentCommonService } from 'projects/Administration/src/app/business-services/appointment-common.service';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { AppLinkService } from 'projects/Administration/src/app/business-services/app-link.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { PaymentMasterService } from 'projects/Administration/src/app/business-services/payment-master.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import * as CommonEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-mg-work-oder-appointment-details',
  templateUrl: './mg-work-oder-appointment-details.component.html',
  styleUrls: ['./mg-work-oder-appointment-details.component.css']
})
export class MgWorkOderAppointmentDetailsComponent implements OnInit {

  constructor(private secureStorage: SecureStorage,
    private appointmentService: AppointmentService,
    public editAppointmentService: EditAppointmentService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private translate: TranslateService,
    public workOrderService: AppointmentWorkOrderService,
    public commonService: AppointmentCommonService,
    private paymentService: PaymentMasterService,
    private clipboardApi: ClipboardService,
    private userService: UserDataService,
    private formBuilder: FormBuilder,
    private appLinkService: AppLinkService
  ) { }
  dealers: DealerViewModel[] = [];
  featureList: Features[] = [];
  shiftDealerId: string;
  contactDetailsCopiedData: AppointmentDetail;
  closeResult: string;
  remark: string = '';
  internalCommentData: string;
  internalComment: string;
  isShiftAppointment: boolean = false;
  StartDate;
  commentType: number;
  paymentTermsList: any;
  paymentMethodList: any;
  commentsLenght: number;
  userId: string;
  commentId: any;
  closeModel: any;
  Addedcomments: any;
  popupCloseResult = false;
  isDsoActive: boolean = false;
  isShareBoxEnabled: boolean = false;
  isPaymentMethodsVisible: boolean = false;
  isPaymentMethodsEditable: boolean = false;
  mechanicKeyDropInfo: AppointmentKeyModel = null;
  customerKeyDropInfo: AppointmentKeyModel = null;  
  editCommentText: any;
  editCommentId:any;
  @Input() isWorkOrderHistory: boolean;
  @Output() updatedAppointmentDetails = new EventEmitter<any>();
  @Output() onShiftAppointment = new EventEmitter<any>();
  editcommentform: FormGroup;

  ngOnInit(): void {
    if (this.userService.currentUserValue?.userRoleMenuDetails) {
      this.isPaymentMethodsVisible = this.userService?.currentUserValue?.userRoleMenuDetails?.find(x=>x.moduleId === ModuleNames.ChangePaymentMethod)?.canView;
      this.isPaymentMethodsEditable = this.userService?.currentUserValue?.userRoleMenuDetails?.find(x=>x.moduleId === ModuleNames.ChangePaymentMethod)?.canEdit;
    }
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList?.length > 0) {
        this.isShiftAppointment = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.ShiftAppointment)?.isActive;
        this.isDsoActive = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.DWO)?.isActive;
        this.isShareBoxEnabled = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.ShareBox)?.isActive;
      }
    }
    this.editcommentform = this.formBuilder.group({
      comment: ['', [Validators.required]],
    })
    this.commonService.appointmentBookedDate = this.commonService.contactDetails.bookedDateTime ? new Date(this.commonService.contactDetails.bookedDateTime + 'Z') : null;
    this.commonService.appointmentCreatedDate = this.commonService.contactDetails.createdDateTime ? new Date(this.commonService.contactDetails.createdDateTime + 'Z') : null;
    this.commonService.appointmentUpdatedDate = this.commonService.contactDetails.updatedDateTime ? new Date(this.commonService.contactDetails.updatedDateTime + 'Z') : null;
    this.commonService.appointmentStatusName = this.commonService.appointmentDetails.appointmentStatus;
    this.getPaymentTerms();
    this.getPaymentMethod();
    this.getKeyDropInfo();
    if (this.commonService.appointmentDetails && this.isWorkOrderHistory) {
      this.commonService.getComments(this.commonService.appointmentDetails.appointmentId);
    }
    else {
      this.commonService.getComments(this.editAppointmentService.appointmentDetails.id);
    }
    this.userId = this.userService.currentUserValue.id;
  }

  emitAppointmentDetail() {
    this.updatedAppointmentDetails.emit({
      updatedAppointmentValues: this.commonService.contactDetails,
    });
  }

  ShiftAppointment(content) {
    let modelHeadermsg = this.translate.instant("lblShiftAppointment");
    let modelBodymsg = this.translate.instant("lblPlanningwillberemoved");
    this.shiftDealerId = '';
    this.remark = '';
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {  // This is intentional
    }, (reason) => {
      let popupCloseResult = this.commonService.getDismissReason(reason);
      if (popupCloseResult) {
        this.commonService.getUserDealers();
        this.commonService.ConfirmShiftAppoitment(content)
      }
    });
  }

  onDealerChange(event) { this.shiftDealerId = event }

  async ChangeDealerOfAppoitment() {
    if (this.shiftDealerId?.length > 0) {
      this.spinner.show();
      this.appointmentService.ShiftAppointment(this.shiftDealerId, this.commonService.appointmentDetails.id, this.remark).then((res) => {
        if (res?.responseObject?.isSuccess) {
          let msg = this.translate.instant("lblShiftAppointmentSuccess");
          this.toastr.success(msg);
        }
        else {
          let msg = this.translate.instant("lbldealerisnotworkingforservices");
          this.toastr.warning(msg);
        }
        this.StartDate = null;
        this.workOrderService.BookingDatetime = null;
        this.commonService.DeliveryDate = null;
        this.commonService.FinnishedDate = null;
        this.commonService.deliveryTimeSlot = { hour: 0, minute: 0 };
        this.commonService.finishTimeSlot = { hour: 0, minute: 0 };
        document.getElementById("modelButton").click();
        this.onShiftAppointment.emit();
        // Generate new CheckIn Link
        this.appLinkService.GetCheckInUrl(this.editAppointmentService.appointmentDetails.appointmentGuid).then(x => {
          this.editAppointmentService.checkInURL = x?.checkInTinyUrl;
        }, _error => { this.spinner.hide(); })

      }).finally(() => { this.spinner.hide() });
    }
    else {
      let msg = this.translate.instant("lblProvideMandatoryValue");
      this.toastr.error(msg);
    }
  }
  async getPaymentTerms() {
    this.spinner.show();
    await this.paymentService.GetPaymentTermDropdown().then((response) => {
      this.spinner.hide()
      this.paymentTermsList = response.responseObject;
    }, _error => {
      this.spinner.hide()
    });
  }
  async getPaymentMethod() {
    this.spinner.show();
    await this.paymentService.GetPaymentMethodDropdown().then((response) => {
      this.spinner.hide()
      this.paymentMethodList = response.responseObject;
    }, _error => {
      this.spinner.hide()
    });
  }
  open(Internalcontent) {
    this.modalService.open(Internalcontent, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }
  copyInternalComments() {
    this.clipboardApi.copyFromContent(this.commonService.internalComment)
  }
  AddInternalComment() {
    if(this.commonService.internalCommentData.trim()){
      this.commonService.AddInternalComment();
      this.commonService.internalCommentData = null;
    }
    else{
      let noSpaceAllowedInComment = this.translate.instant("lblOnlySpaceNotAllowed");
      this.toastr.error(noSpaceAllowedInComment);
    }
  }
 
  
  ViewComment(viewContent, commentType) {
    this.commentType = commentType
    this.commonService.CommentsByCount(this.commentType);
    this.modalService.open(viewContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }
  EditComment(editcontent, comment) {
    this.editCommentText = comment.comment;
    this.editCommentId = comment.id;
    this.closeModel = this.modalService.open(editcontent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
  }
  EditCommentDetails() {
    this.commonService.EditCommentDetails(this.editCommentText,this.editCommentId);
    this.closeModel.close();
  }
  DeleteComment(Comments: any) {
    this.commonService.DeleteComment(Comments);
  }
  getKeyDropInfo(): void {
    if (this.isShareBoxEnabled) {
      let keyList = this.commonService.contactDetails.appointmentKeyList;
      if (keyList && keyList.length > 0) {
       this.isKeyListAvailable(keyList)
      }
    }
  }

  isKeyListAvailable(keyList:any)
  {
    keyList.forEach(item => {
      if (item.exchangeMethod == 0) {
        item.keyPickUpDate = item.keyPickUpDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.keyPickUpDate + "Z")) : null;
        item.assignLockerDate = item.assignLockerDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.assignLockerDate + "Z")) : null;
        this.customerKeyDropInfo = item;
      }
      else if (item.exchangeMethod == 1) {
        item.keyPickUpDate = item.keyPickUpDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.keyPickUpDate + "Z")) : null;
        item.assignLockerDate = item.assignLockerDate ? Utility.ConvertUTCDateToLocalDate(new Date(item.assignLockerDate + "Z")) : null;
        this.mechanicKeyDropInfo = item;
      }
    });
  }
}